<template>
    <div class="pt-0" style="width: 100%">
        <v-parallax :src="heroImage" height="400" :alt="imageAltText">
            <triangle-div
                :borderBottom='mediumScreen ? "250px solid #00B1C3" : "150px solid #00B1C3"'
                :borderLeft='mediumScreen ? "600px solid transparent" : "150px solid transparent"'
                :borderRight="'0px solid transparent'"
                :width='mediumScreen ? "400px" : "20px"'
            ></triangle-div>

            <h2 class="page-header text-h4 text-uppercase">{{ pageTitle }}</h2>
        </v-parallax>
    </div>
</template>

<script>
import TriangleDiv from './TriangleDiv.vue'

export default {
    components: {
        'triangle-div': TriangleDiv,
    },
    name: 'PageHero',
    props: {
        /**
         * The src of the image that should be displayed.
         */
        heroImage: String,
        /**
         * A string title for the current page
         */
        pageTitle: {
            type: String,
            default: "Page Title Here"
        },
        /** The alt text to be used with the hero image. */
        imageAltText: String
    },
    computed: {
      mediumScreen () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return false
          case 'sm': return false
          case 'md': return true
          case 'lg': return true
          case 'xl': return true
          default: return false
        }
      },
    },
}
</script>

<style scoped>
.page-header {
    z-index: 999;
    position: absolute;
    bottom: 15%;
    right: 15%;
}
</style>